import { CAR_IMAGES } from '../context/AuctionFilters/data/brand-images/brand-images';

export function transformMarks(marks) {
  return marks.map(mark => {
    const pos = mark.replace(/-| /g, '');
    return { value: mark, image: CAR_IMAGES[pos] || '' };
  });
}
